let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aDU9W")).then(() => parcelRequire('44BMx'));